import './RouteCredits.scss'
import { Link } from 'react-router-dom';
import Button from '../../../../shared/src/components/atoms/button/button';
import iconTrophy from 'assets/icon-route.svg';
import gestionCreditos from 'assets/credits/Gestión_Créditos.svg';
import aspectoslegalesRegulatorios from 'assets/credits/Aspectos_legales_regulatorios.svg';
import procesoSolicitudCreditos from 'assets/credits/Proceso_solicitud_créditos.svg';
import tiposCreditos from 'assets/credits/Tipos_Créditos.svg';
import practicasCreditoResponsable from 'assets/credits/Prácticas_crédito_Responsable.svg';
import ContainerTem from 'components/molecules/container-tem/ContainerTem';

const DATA_TEM = [
	{
		"titulo": "Proceso de solicitud de créditos",
		"temas": [
			"Requisitos y documentación necesaria",
			"Evaluación de la capacidad de endeudamiento",
			"Evaluación del historial crediticio",
			"Intereses y cargos adicionales",
			"Plazos y condiciones de pagos mensuales",
			"Garantías: pagaré"
		],
		"imagen": procesoSolicitudCreditos
	},
	{
		"titulo": "Características y costos del crédito",
		"temas": [
			"Estrategias para el manejo efectivo del crédito",
			"Importancia del presupuesto personal",
			"Gestión de deudas y refinanciamiento",
			"Interés de mora",
			"Impacto del historial crediticio",
			"Pagos fuera del plazo establecido",
			"Abonos a capital"
		],
		"imagen": gestionCreditos
	},
	{
		"titulo": "Prácticas de crédito responsable",
		"temas": [
			"Buenas prácticas para utilizar el crédito de manera responsable",
			"Herramientas y recursos para monitorear y controlar el uso del crédito",
			"Estrategias para evitar el sobreendeudamiento y los problemas financieros",
			"Metodología de Enseñanza"
		],
		"imagen": practicasCreditoResponsable
	}
]


const RouteCredits = () => {
	return (
		<div className='route'>
			<header className="route-header">
				<div className="route-header__container-button">
					<button className="route-header__container-button__back-button">
						<span className="material-icons md-18">arrow_back</span>
						<p>Volver</p>
					</button>
				</div>
				<div className="route-header__text">
					<h3>¿Te gustaría tener el conocimiento necesario para solicitar y manejar créditos sin complicaciones?</h3>
					<p>Este curso te brinda las herramientas prácticas y el entendimiento profundo que necesitas para hacerlo.</p>
					<p>¡Prepárate para tomar el control de tus finanzas!</p>
				</div>
				<Link className='link' to={`/dashboard-course-credits`}>
					<Button gtmClass='secondary' className='button-link'>Iniciar curso</Button>
				</Link>
			</header>
			<div className="route-container">
				<section className="route-result">
					<div className="route-result__content">
						<h2>Contenido</h2>
						<div className="route-result__content__icon">
							<img src={iconTrophy} alt="Icono trofeo" />
						</div>
					</div>
					<div className='route-result__tems'>
					{
						DATA_TEM.map((reg, index) => {
							return <ContainerTem
								key={index}
								titulo={reg.titulo} 
								temas={reg.temas} 
								imagen={reg.imagen}
								intercalar={index % 2 === 0} 
							/>
						})
					}
					</div>

				</section>
			</div>
			<footer className="route-footer">
				<Link className='link' to={`/dashboard-course-credits`}>
					<Button gtmClass='secondary' className='button-link'>Iniciar curso</Button>
				</Link>
				<span className='decoration'>
				</span>
			</footer>
		</div>
	)
}

export default RouteCredits